import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=254dfd6e&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"
import style0 from "./avatar.vue?vue&type=style&index=0&id=254dfd6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254dfd6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254dfd6e')) {
      api.createRecord('254dfd6e', component.options)
    } else {
      api.reload('254dfd6e', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=254dfd6e&scoped=true", function () {
      api.rerender('254dfd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/avatar.vue"
export default component.exports